import { Empty, Skeleton, Table, Tooltip, Switch, message } from 'antd'
import React, { useState } from 'react'
import moment from 'moment'

import { useVideoGuides, useToggleVideoGuideArchive } from "../../hooks/userGuides";

const VideoGuideList = (props) => {

    const sortDirections = ['ascend', 'descend', 'ascend'];
    const [pageSize, setPageSize] = useState(10);

    const { showModal } = props;

    const { data: filteredData = [], isFetching } = useVideoGuides();
    

    const toggleArchive = useToggleVideoGuideArchive();

    const onArchiveToggle = (record) => {        
        return async (checked) => {
            
            await toggleArchive.mutateAsync({ uuid: record.uuid, archived: checked })
                .catch((err)=> {console.error("ERROR: ", err);});
        }
    };

    const columns = [
        {
            title: "Title",
            dataIndex: "title",
            key: "title-1",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
        },
        {
            title: "Module name",
            dataIndex: "targetModule",
            key: "targetModule-2",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return String(a.targetModule).localeCompare(String(b.targetModule));
            },
        },
        {
            title: "Media Id",
            dataIndex: "mediaId",
            key: "3",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            defaultSortOrder: "descend",
        },
        // {
        //     title: "Provider",
        //     dataIndex: "provider",
        //     key: "provider-3b",
        //     showOnResponse: true,
        //     showOnDesktop: true,
        //     sortDirections: sortDirections,
        //     defaultSortOrder: "descend",
        // },
        {
            title: "Modified Date",
            dataIndex: "lastModified",
            key: "lastModified-4",
            render: (text) => {
                return text != null ? moment(text).format("DD MMM YYYY") : "";
            },
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            defaultSortOrder: "descend",
            sorter: (a, b) => {
                return String(a?.lastModified ?? '').localeCompare(String(b?.lastModified ?? ''));
            },
        },
        {
            title: "Archived",
            dataIndex: "archived",
            key: "archived-3b",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                
                const isArchived = !!record.archived;
                
                return (
                    <Tooltip title={isArchived ? "Un-archive guide" : "Archive guide"}>
                        <Switch
                            checkedChildren="Yes" unCheckedChildren="No"
                            style={{ marginLeft: "20px" }}
                            checked={isArchived}
                            onChange={onArchiveToggle(record)}
                        />
                    </Tooltip>
                );
            }
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions-1",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {             

                return (
                    <>
                        <>
                            <a key={"a-" + record.uuid} onClick={() => showModal(record, "view")}>View</a>
                            <a key={"b-" + record.uuid} onClick={() => showModal(record, "edit")}>
                               <span style={{ paddingLeft: "20px" }}></span> Edit
                            </a>
                        </>
                    </>
                );
            },
        },
    ]

    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };
    

    return (
        <>
            <div className="space"></div>
            <Table
                dataSource={isFetching ? [] : filteredData}
                locale={{
                    emptyText: isFetching ? <Skeleton active={true} /> : <Empty />,
                }}
                columns={columns}
                rowKey={(record) =>  record.uuid}
                bordered
                pagination={{ pageSize: pageSize }}
                onChange={onRowChange}
                size="middle"
                mobileBreakPoint={768}
                loading={isFetching}
            />
        </>
    )
}

export default VideoGuideList;
